import React, { memo, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { Box } from '@mui/material';
import PageBlock from '@sharedCR/common/PageBlock';
import PropTypes from 'prop-types';

import { selectLiveRunsByOwner, selectProcessesUsedByOwner } from 'store/aiProcessRuns';

import { LIVE_CARD_TITLE } from '../AiActivity.constants';
import { AiActivityTestIds } from '../AiActivity.testIds';
import { resolveProcessName } from '../AiActivity.utils';

import LiveCardRow from './components/LiveCardRow';
import { listStyles } from './LiveCard.styles';

const LiveCard = ({ ownerId, onSelectExecution }) => {
  const liveRuns = useSelector(selectLiveRunsByOwner(ownerId));
  const processes = useSelector(selectProcessesUsedByOwner(ownerId));

  const processesById = useMemo(
    () => Object.fromEntries((processes ?? []).map(item => [item.id, item])),
    [processes],
  );

  if (liveRuns.length === 0) {
    return null;
  }

  return (
    <PageBlock title={LIVE_CARD_TITLE}>
      <Box data-testid={AiActivityTestIds.LIVE_CARD} sx={listStyles}>
        {liveRuns.map(run => (
          <LiveCardRow
            key={run.id}
            processName={resolveProcessName(run, processesById)}
            run={run}
            onSelectExecution={onSelectExecution}
          />
        ))}
      </Box>
    </PageBlock>
  );
};

LiveCard.propTypes = {
  onSelectExecution: PropTypes.func.isRequired,
  ownerId: PropTypes.string,
};

export default memo(LiveCard);
